import { render, staticRenderFns } from "./VatRegimeOrder.vue?vue&type=template&id=34052645"
import script from "./VatRegimeOrder.vue?vue&type=script&lang=ts"
export * from "./VatRegimeOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34052645')) {
      api.createRecord('34052645', component.options)
    } else {
      api.reload('34052645', component.options)
    }
    module.hot.accept("./VatRegimeOrder.vue?vue&type=template&id=34052645", function () {
      api.rerender('34052645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/VatRegimeOrder.vue"
export default component.exports